import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import './index.css'

// Create a new router instance with aggressive preloading
const router = createRouter({ 
    routeTree,
    defaultPreload: 'intent',
    defaultPreloadDelay: 50, // 50ms hover triggers preload
})

try {
    // EMERGENCY CLEAR: Recover from Chromium LevelDB FILE_ERROR_NO_SPACE 
    // that bricked the user's browser storage due to previous write-amplification bug.
    // If NO_SPACE error occurs again, uncomment these lines.
    // indexedDB.deleteDatabase('options-oracle-cache');
    // indexedDB.deleteDatabase('options-oracle-store');
    // console.log('[Recovery] Forcibly cleared IndexedDB databases to recover from NO_SPACE error.');
} catch (e) {
    console.error('[Recovery] Failed to clear IDB:', e);
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
    // console.log( "[Router Init] Browser URL:", window.location.href );
    // console.log( "[Router Init] Router path:", router.state.location.pathname );

    // Listen to changes
    router.subscribe('onResolved', (state: any) => {
        // console.log( "[Router State] Navigated to:", state.toLocation.pathname );
    })

    const root = createRoot(rootElement)
    root.render(<RouterProvider router={router} />)
}
